<template>
  <div id="process-header" class="is-marginless is-paddingless">
    <div class="is-vcentered navigation has-background-color-7">
      <section
        class="menu-header pb-5 has-background-color-7 is-align-items-center"
      >
        <b-button
          iconLeft="menu"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          :class="{
            'has-background-color-7': isContrast,
            'is-hidden-tablet': true
          }"
          @click="openSideBar"
        />
        <img
          v-if="isMobile"
          class="govern-project-logo auto-height"
          :alt="Home.TopNavigationBar.ALT.GOV_SEPLAG"
          :src="isContrast ? govSuiteMobileLogoContrast : govSuiteMobileLogo"
          @click="goToHomePage"
        />
        <img
          v-else
          class="govern-project-logo py-5 pl-20"
          :alt="Home.TopNavigationBar.ALT.GOV_SEPLAG"
          :src="isContrast ? govSuiteLogoContrast : govSuiteLogo"
          @click="goToHomePage"
        />
        <div
          v-if="!giveKnowledgeId"
          class="is-flex is-hidden-mobile is-justify-content-space-between flex-1 is-align-items-center pl-45"
        >
          <div class="has-text-color-1 is-size-4 has-text-weight-semibold p-10">
            {{ App.ProcessViewer.TITLE_VIEWER }}
          </div>
          <div class="action-buttons">
            <b-button
              :type="isContrast ? 'is-white' : 'is-green-lawn'"
              expanded
              tag="router-link"
              :to="detailRouter"
            >
              {{ App.ProcessViewer.RETURN_DETAILS }}
            </b-button>

            <b-tooltip
              multilined
              class="mr-5"
              :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
              size="is-large"
              :position="isMobile ? 'is-top' : 'is-left'"
              role="tooltip"
            >
              <template v-slot:content>
                <section class="has-text-left">
                  <p class="has-text-color-1 has-text-weight-bold">
                    {{ App.ProcessViewer.VIEW_COMPLETE_FILE }}
                  </p>
                  {{ App.ProcessViewer.MESSAGE_COMPLETE_FILE }}
                </section>
              </template>
              <b-button
                :type="isContrast ? 'is-white' : 'is-green-lawn'"
                iconLeft="file-pdf-box"
                @click="requestDownloadProcess"
              >
                {{ App.ProcessViewer.COMPLETE_FILE }}
              </b-button>
            </b-tooltip>
          </div>
        </div>
        <b-dropdown
          aria-role="list"
          position="is-bottom-left"
          class="is-hidden-tablet is-align-items-center"
          :mobileModal="false"
        >
          <template #trigger>
            <b-button
              v-if="!giveKnowledgeId"
              iconLeft="dots-vertical"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              :class="{ 'has-background-color-7': isContrast }"
            />
          </template>

          <b-dropdown-item aria-role="listitem" @click="goDetails">
            {{ App.ProcessViewer.RETURN_DETAILS }}
          </b-dropdown-item>
          <b-dropdown-item aria-role="listitem" @click="requestDownloadProcess">
            {{ App.ProcessViewer.COMPLETE_FILE }}
          </b-dropdown-item>
        </b-dropdown>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { App, Home, General } from "@/utils/constants";
import govSuiteLogo from "@/assets/images/APP_HEADER_LOGO.png";
import govSuiteLogoContrast from "@/assets/images/APP_HEADER_LOGO_contrast.png";
import ProcessDownloadStep from "@/components/ProcessDownloadStep";
import govSuiteMobileLogo from "@/assets/images/Logotipo_CE_Branca.svg";
import govSuiteMobileLogoContrast from "@/assets/images/Logotipo_CE.svg";
import {
  USER_PERMISSIONS as userPermissions,
  PROCESS_DOWNLOAD_STATUS as STATUS
} from "@/utils/enumerate";
import ModalWarning from "@/views/App/ModalWarning";

export default {
  name: "ProcessPageHeader",
  props: {
    openSideBar: {
      type: Function,
      default: () => null
    },

    isConfidential: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      App,
      Home,
      General,
      govSuiteLogo,
      govSuiteLogoContrast,
      govSuiteMobileLogo,
      govSuiteMobileLogoContrast
    };
  },
  computed: {
    ...mapGetters(["hasPermission", "isContrast", "isMobile"]),
    processId() {
      return this.$route.params.id;
    },
    processNup() {
      return this.$attrs.nup.replace(/\D/g, "");
    },
    detailRouter() {
      return `/app/processos/detalhamento/${this.processId}`;
    },
    giveKnowledgeId() {
      return this.$route.query.give_knowledge_id;
    },
    hasPermissionViewConfidential() {
      return this.hasPermission(userPermissions["VIEW_CONFIDENTIAL_PROCESS"]);
    }
  },
  methods: {
    ...mapActions(["checkAndAddProcessDownlaod"]),
    ...mapMutations(["removeProcessDownload"]),
    goToHomePage() {
      window.open("/app/processos", "_blank");
    },
    requestDownloadProcess() {
      if (this.isConfidential) {
        this.$buefy.modal.open({
          parent: this,
          component: ModalWarning,
          props: {
            title: `${this.General.WARNING}!`,
            message: this.General.MESSAGES.ALERT_PROCESS_SECRECY,
            invertOutline: true,
            confirm: this.putProcessInQueue,
            buttons: [
              { label: General.YES, isConfirm: true, action: true },
              { label: General.NO, isConfirm: false, action: false }
            ]
          },
          hasModalCard: true,
          trapFocus: true
        });
      } else {
        this.putProcessInQueue();
      }
    },
    async putProcessInQueue() {
      const success = await this.checkAndAddProcessDownlaod({
        processId: this.processId,
        status: STATUS.PENDING,
        lastState: Date.now()
      });
      this.snackQueue.open({
        id: `download_process:${this.processId}`,
        parent: this,
        props: {
          processId: this.processId,
          nup: this.processNup
        },
        component: ProcessDownloadStep,
        closeAction: ({ processId }) => this.removeProcessDownload(processId)
      });
      if (!success)
        this.snackToast.open({
          message: this.General.MESSAGES.PROCESSE_ALREADY_ADD,
          type: "is-danger",
          duration: 8000
        });
    },
    goDetails() {
      this.$router.push(this.detailRouter);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";
#process-header {
  background-color: var(--color-2);
  color: var(--color-8);
  border-bottom: 10px solid $green-light;
  min-height: 65px;
  width: auto;
}

.action-buttons {
  display: flex;
  gap: 10px;
}
</style>
